module.exports = __webpack_public_path__ + "img/bluetick_small_icone.f5602dcb.png";